import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { LanguageSwitcher } from '@/components/LanguageSwitcher';

interface AuthLayoutProps {
  children: ReactNode;
  title: string;
  subtitle: string;
  backTo?: string;
  backLabel?: string;
}

export default function AuthLayout({ children, title, subtitle, backTo, backLabel }: AuthLayoutProps) {
  return (
    <div className="poppy-auth flex min-h-screen flex-col bg-background text-foreground">
      <header className="flex items-center justify-between px-6 py-6 sm:px-10 sm:py-8">
        <Link to={backTo || '/login'} aria-label="ThePoppyApp" className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-primary text-primary-foreground transition-opacity hover:opacity-80">
          <img src="/logo_poppy.png" alt="The Poppy App" className="h-8 w-auto" />
        </Link>
        <LanguageSwitcher />
      </header>
      <main className="flex flex-1 items-center justify-center px-6 pb-16 pt-8 sm:pb-20 sm:pt-10">
        <div className="w-full max-w-[420px]">
          <div className="mb-8 text-center">
            <p className="mb-3 font-display text-sm font-medium text-muted-foreground">ThePoppyApp<span className="text-accent">.</span></p>
            <h1 className="text-3xl font-semibold leading-tight tracking-normal">{title}</h1>
            <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{subtitle}</p>
          </div>
          {children}
        </div>
      </main>
      <footer className="flex min-h-16 items-center justify-center px-6 pb-6 text-xs text-muted-foreground">
        {backTo && <Link to={backTo} className="inline-flex items-center gap-2 transition-colors hover:text-foreground"><ArrowLeft className="h-3.5 w-3.5" />{backLabel}</Link>}
      </footer>
    </div>
  );
}